<template>
  <div class="timer-component-container">
    <div class="timer-container">
      <div class="timer-controls-container">
        <input
          type="button"
          value="+"
          class="timer-controls"
          @click="incrementTime"
        />
        <input
          type="button"
          value="-"
          class="timer-controls"
          @click="decrementTime"
        />
      </div>
      <input
        type="button"
        v-shortkey.once="[keyMap.timer.startTimer.toLowerCase()]"
        @shortkey="startTimer"
        :title="`Start Timer (${keyMap.timer.startTimer.toUpperCase()})`"
        @click="startTimer"
        :class="{
          timer: true,
          'timer-button-warning': getDisplayTime <= WARNING_THRESHOLD,
        }"
        :value="getDisplayTime"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "TimerComponent",
  data() {
    return {
      displayTime: this.directTime,
      WARNING_THRESHOLD: 10,
    };
  },
  computed: {
    ...mapGetters(["getOnDirect", "getDisplayTime"]),
    ...mapState(["timer", "showSettings", "keyMap"]),
  },
  methods: {
    ...mapActions([
      "startTimer",
      "gotoSettings",
      "incrementTime",
      "decrementTime",
    ]),
  },
};
</script>

<style scoped>
.timer-component-container {
  height: 70px;
  display: flex;
  justify-content: flex-end;
}

.timer-container {
  display: flex;
}

.timer-controls-container {
  display: flex;
  flex-direction: column;
}

.timer-controls {
  width: 35px;
  height: 50%;
  background-color: black;
  line-height: 50%;
  color: white;
  font-size: 35px;
  border: none;
  cursor: pointer;
}

.timer-controls:hover {
  background-color: #333333;
}

.timer {
  font-family: Consolas, Menlo, "Courier New", Courier, monospace;
  background-color: lightblue;
  height: 100%;
  font-size: 30px;
  padding: 0 15px;
  width: 70px;
  cursor: pointer;
}

.timer-button-warning {
  background-color: lightpink;
}
</style>